import React from 'react';
import data from '../data.json';
import '../style.css';

function About() {
  const aboutData = data.aboutPage;

  return (
    <div className="container my-5">
      <h1 className="text-center mb-5 fw-bold" data-aos="fade-down">{aboutData.headline}</h1>

      {/* Mission Section */}
      <div className="row align-items-center mb-5" data-aos="fade-right">
        <div className="col-md-6">
          <h2>{aboutData.mission.title}</h2>
          <p>{aboutData.mission.text}</p>
        </div>
        <div className="col-md-6">
          <img src={aboutData.mission.image} className="img-fluid rounded shadow-sm" alt="Mission" />
        </div>
      </div>

      {/* Unique Values */}
      <h2 className="mb-4" data-aos="fade-left">💎 Our Unique Value Propositions</h2>
      <div className="row mb-5">
        {aboutData.values.map((val, i) => (
          <div className="col-md-4 mb-4" key={i} data-aos="zoom-in">
            <div className="card p-4 text-center">
              <h4 className="mb-3">{val.title}</h4>
              <p>{val.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Client Testimonials */}
  <h2 className="mb-4" data-aos="fade-up">🌟 Meet the People Behind Our Success</h2>
      <div className="row text-center">
        {aboutData.faculty.map((f, i) => (
          <div className="col-md-3 mb-4" key={i} data-aos="zoom-in-up">
            <div className="card p-3">
              <img
                src={f.photo}
                className="card-img-top rounded-circle mb-3"
                alt={f.name}
                style={{ height: '150px', width: '150px', objectFit: 'cover', margin: '0 auto' }}
              />
              <h5>{f.name}</h5>
              <div>
                {f.socials.map((icon, j) => (
                  <i key={j} className={`fab ${icon} me-2`}></i>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default About;
